function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import service from "./services";

var User = /*#__PURE__*/function () {
  function User() {
    _classCallCheck(this, User);
  }

  _createClass(User, null, [{
    key: "current",
    get: function get() {
      if (typeof this.user === "undefined") {
        var user = service.SiteData.read('user');
        this.user = typeof user !== "undefined" && user !== null ? {
          nick: user.nick,
          id: user.id,
          guid: user.guid,
          avatar: user.avatar,
          roles: user.roles
        } : false;
      }

      return this.user;
    }
  }]);

  return User;
}();

export { User as default };